import { useCallback } from "react";
import { Item } from "../state_management/reducers/cart";

export const useInCart = (id: number, cart: Item[]) => {
  const Item = useCallback(
    (id: number) => {
      const item = cart.find((cart_item) => {
        return cart_item.id === id;
      });
      return item;
    },
    [cart]
  );
  return Item(id);
};
